import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdateCourseTermsMutation = graphql.persisted(
  "UpdateCourseTerms",
  graphql(`
    mutation UpdateCourseTerms($input: UpdateCourseTermsInput!) {
      updateCourseTerms(input: $input) {
        course {
          id
          name
          terms {
            id
            name
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateCourseTermsMutation };

export function useUpdateCourseTerms() {
  return useMutation(UpdateCourseTermsMutation);
}
